import { useDispatch, useSelector } from 'react-redux';

import appSelectors from 'redux/app/appSelectors';

import authOperations from 'redux/auth/authOperations';

import LogoutIcon from 'images/header/logout.svg?react';

import s from './btnLogout.module.css';

function BtnLogout() {
  const dispatch = useDispatch();
  const i18n = useSelector(appSelectors.translation);

  const logout = () => dispatch(authOperations.logout());

  return (
    <button
      type="button"
      onClick={logout}
      className={s.btn_logout}
      title="logout"
    >
      <LogoutIcon />
      {i18n.Выйти}
    </button>
  );
}

export default BtnLogout;
